import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { StyledContainer, StyledTelescopeIcon } from './component.styles'
import {
  BANNER_STRONG_TEXT,
  BANNER_LINK_TEXT,
  BANNER_STRONG_TEXT_TRAINING,
  BANNER_LINK_TEXT_TRAINING,
  BANNER_STRONG_TEXT_TIER2,
  BANNER_LINK_TEXT_TIER2,
  BANNER_SCROLL_THRESHOLD,
  MARGIN_TOP_DEFAULT,
  MARGIN_TOP_MOBILE,
  MARGIN_TOP_SCROLL,
  MOBILE_LARGE_BREAKPOINT,
} from './constants'
import previewBanner from './assets/ss_curriculumpreview_banner.svg'
import { Link } from 'react-router-dom'
import { isTier2Url } from 'utils/urlHelpers'

const CoursePreviewBanner = ({
  customTopMargin,
  extractLessonsLink,
  isTraining = false,
  lessonsLink,
}) => {
  const [dynamicCSSPosition, setDynamicCSSPosition] = useState('relative')

  // Use customTopMargin if provided, otherwise fall back to defaults
  const getDefaultMarginTop = () => {
    if (customTopMargin !== undefined) {
      return customTopMargin
    }
    return window.innerWidth <= MOBILE_LARGE_BREAKPOINT
      ? MARGIN_TOP_MOBILE
      : MARGIN_TOP_DEFAULT
  }

  const [dynamicMarginTop, setDynamicMarginTop] = useState(
    getDefaultMarginTop(),
  )

  // Use different text based on training state and tier-2 detection
  const isTier2 = isTier2Url()
  const bannerText = isTraining
    ? BANNER_LINK_TEXT_TRAINING
    : isTier2
    ? BANNER_LINK_TEXT_TIER2
    : BANNER_LINK_TEXT
  const strongText = isTraining
    ? BANNER_STRONG_TEXT_TRAINING
    : isTier2
    ? BANNER_STRONG_TEXT_TIER2
    : BANNER_STRONG_TEXT
  const goTolessonsParts = extractLessonsLink(bannerText)

  /*
   simulate position: sticky

   actually setting position to sticky would require a lot of CSS work to position
   the header and the footer correctly so they scroll on and off screen
  */
  const handleScroll = () => {
    if (window.scrollY > BANNER_SCROLL_THRESHOLD) {
      setDynamicCSSPosition('fixed')
      setDynamicMarginTop(MARGIN_TOP_SCROLL)
    } else {
      setDynamicCSSPosition('relative')
      // need a negative offset if at the top of the screen:
      if (customTopMargin !== undefined) {
        setDynamicMarginTop(customTopMargin)
      } else if (window.innerWidth <= MOBILE_LARGE_BREAKPOINT) {
        setDynamicMarginTop(MARGIN_TOP_MOBILE)
      } else {
        setDynamicMarginTop(MARGIN_TOP_DEFAULT)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <StyledContainer
      bannerImage={previewBanner}
      style={{
        position: dynamicCSSPosition,
        marginTop: dynamicMarginTop,
      }}
    >
      <StyledTelescopeIcon aria-hidden="true" role="presentation" />
      <div>
        <p>
          <strong>{strongText}</strong>
        </p>
        <p>
          {/* first match [0] is the whole string */}
          {goTolessonsParts[1]}
          <Link to={lessonsLink}>{goTolessonsParts[2]}</Link>
          {goTolessonsParts[3]}
        </p>
      </div>
    </StyledContainer>
  )
}

CoursePreviewBanner.propTypes = {
  customTopMargin: PropTypes.string,
  extractLessonsLink: PropTypes.func,
  isTraining: PropTypes.bool,
  lessonsLink: PropTypes.string,
}

export default CoursePreviewBanner
